import { LocalizedText, useAppClockService } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { useCommanderSelector } from '@mews-commander/utils';
import { getLocalizedFilterValues } from '../selectors';

export const PayoutReportHeader = () => {
    const appClockService = useAppClockService();
    const { startDate, endDate } = useCommanderSelector((state) =>
        getLocalizedFilterValues(state, { appClockService })
    );

    return <LocalizedText textKey={TextKey.PayoutReportHeader} substitutes={{ from: startDate, to: endDate }} />;
};
